const AUTH_TRACE_FLOW_START_KEY = 'uf:auth:trace:flow-start';

const hasWindow = () => typeof window !== 'undefined';

const isEnabled = () => {
  if (!hasWindow()) return false;
  if ((import.meta as ImportMeta).env?.VITE_AUTH_TRACE === 'false') return false;
  return true;
};

const toIso = (value: number) => new Date(value).toISOString();

export const startAuthFlowTrace = (event: string, payload?: Record<string, unknown>) => {
  if (!hasWindow()) return;
  const now = Date.now();
  window.sessionStorage.setItem(AUTH_TRACE_FLOW_START_KEY, String(now));
  traceAuth(event, payload);
};

export const clearAuthFlowTrace = () => {
  if (!hasWindow()) return;
  window.sessionStorage.removeItem(AUTH_TRACE_FLOW_START_KEY);
};

export const traceAuth = (event: string, payload?: Record<string, unknown>) => {
  if (!isEnabled()) return;

  const now = Date.now();
  let flowStartedAt: number | null = null;
  if (hasWindow()) {
    const raw = window.sessionStorage.getItem(AUTH_TRACE_FLOW_START_KEY);
    const parsed = Number(raw);
    flowStartedAt = Number.isFinite(parsed) ? parsed : null;
  }

  const deltaMs = flowStartedAt ? now - flowStartedAt : null;
  const base = {
    ts: toIso(now),
    event,
    deltaMs
  };
  if (payload) {
    console.log('[auth-trace]', { ...base, ...payload });
    return;
  }
  console.log('[auth-trace]', base);
};
